export class Error {
  route?: string;
  image?: string;
  title?: string;
  width?: string;
  content?: string;
  bullets?: string[];
  link?: {
    url: string;
    text: string;
  };
  mobile?: {
    url: string;
    text: string;
  };
  redirect?: {
    url: string;
    text: string;
    queryParams?: object;
  };
}
